import React from 'react'
import PropTypes from 'prop-types'

const Logo = ({ size }) => {
  let logoClass = 'app-logo'

  if (size === 'medium') {
    logoClass = `${logoClass} medium-logo`
  } else if (size === 'large') {
    logoClass = `${logoClass} large-logo`
  }

  return (
    <img
      alt="Vobo"
      className={logoClass}
      src="/assets/images/logo-128.png"
    />
  )
}

Logo.defaultProps = {
  size: '',
}

Logo.propTypes = {
  size: PropTypes.string,
}

export default Logo



// WEBPACK FOOTER //
// ./src/browser/components/Logo.js